module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10185.2d9fddec.jpg";